import Settings from '@engine/features/dashboard/chart/dashboard_chart_settings';
import Util from '@engine/features/dashboard/chart/dashboard_chart_utility';
var locales = {
  delta: 'javascript.charts.delta',
  volume: 'javascript.charts.volume',
  count: 'javascript.charts.count'
}; // Utility methods for Configs

function yAxes(options) {
  return [{
    scaleLabel: {
      display: true,
      labelString: options.labelString
    },
    ticks: {
      beginAtZero: true,
      callback: function callback(value) {
        return Util.formatVolume(value);
      }
    }
  }];
}

function dataPoint(item, data) {
  var dataset = data.datasets[item.datasetIndex];
  var point = dataset.data[item.index];
  return point;
} // Custom Options
// Volumes & Delta specifyc options


function optionsForDelta() {
  return {
    tooltips: {
      callbacks: {
        label: function label(item, data) {
          var point = dataPoint(item, data);
          return '  ' + I18n.t(locales.delta) + ': ' + point.y + '%';
        }
      }
    },
    scales: {
      yAxes: yAxes({
        labelString: I18n.t(locales.delta) + ' %'
      })
    }
  };
}

function optionsForVolume() {
  return {
    tooltips: {
      callbacks: {
        label: function label(item, data) {
          var point = dataPoint(item, data);
          var volume = I18n.t(locales.volume) + ': ' + Util.formatVolume(point.y);
          var count = I18n.t(locales.count) + ': ' + point.count;
          return '  ' + volume + ',  ' + count;
        }
      }
    },
    scales: {
      yAxes: yAxes({
        labelString: I18n.t(locales.volume)
      })
    }
  };
} // Base Default Options
// All Options extended with the custom options


function defaults() {
  var scales = {
    xAxes: [{
      type: 'time',
      time: {
        unit: 'day',
        tooltipFormat: Settings.LABEL_FORMAT
      },
      gridLines: {
        display: false
      }
    }]
  };
  var tooltips = {
    mode: 'index',
    intersect: false,
    xPadding: 10,
    yPadding: 10
  };
  var options = {
    maintainAspectRatio: false,
    scales: scales,
    tooltips: tooltips,
    hover: {
      mode: 'index',
      intersect: false
    },
    elements: {
      line: {
        // Disables bezier curves
        tension: 0
      }
    },
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 12,
        padding: 20
      }
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    },
    title: {
      display: true,
      text: '...'
    }
  };
  $.extend(true, options, optionsForVolume());
  return options;
}

export default {
  defaults: defaults,
  forDelta: optionsForDelta,
  forVolume: optionsForVolume
};